<img class="single-new-image" src="{{news.pictureUrl}}" alt="news picture">
<div class="single-new-description">
  <div><strong>{{news.title | translatedb | uppercase}}</strong></div>
  <div class="single-new-date"><em>{{"PUBLISHED_ON" | translate}}: {{news.date}}</em></div>
  <div [innerHTML]="news.description | translatedb"></div>
  <a class="single-new-link" href="{{news.link}}" target="_blank">{{"LINK_TO_NEWS" | translate}}</a>
</div>
